import { render, staticRenderFns } from "./choose_partner_age.vue?vue&type=template&id=0d37582a&scoped=true&"
import script from "./choose_partner_age.vue?vue&type=script&lang=js&"
export * from "./choose_partner_age.vue?vue&type=script&lang=js&"
import style0 from "./choose_partner_age.vue?vue&type=style&index=0&id=0d37582a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d37582a",
  null
  
)

export default component.exports